module.exports = __webpack_public_path__ + "img/fg.be699fbb.png";